// The time a Quick Schedule slot shows.
//
// The dialog formatted each slot's instant in the browser's zone, so a laptop
// set to another zone offered times the clinic does not have — while the
// calendar grid behind it, which shows the clinic's clock whatever machine
// is looking, was right. Times belong to the practice, not to the machine:
// the slot carries the clinic's own clock as text ("13:00"), and that is
// what is shown, as the task panel and the grid already do. The instant is
// a last resort for a slot that carries no clock time at all.
import { formatClockString, formatTimeOnly } from '../../utils/dateTime';

export interface QuickSlotLike {
  time?: string | null;
  timeDisplay?: string | null;
  startTime?: string | null;
}

export function quickSlotLabel(slot: QuickSlotLike): string {
  if (slot.timeDisplay) return slot.timeDisplay;
  if (slot.time && /^\d{1,2}:\d{2}/.test(slot.time)) return formatClockString(slot.time);
  const start = new Date(String(slot.startTime || ''));
  if (Number.isNaN(start.getTime())) return String(slot.startTime || '');
  return formatTimeOnly(start, undefined, false);
}
